<template>
  <div class="content-wrapper" :data-ref="REFS.CONTENT_WRAPPER">
    <slot />
  </div>
</template>

<script>
import { REFS } from '@/utils/enums/external-refs'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'ALayoutContentContainer',
  mixins: [hydrationHelpers],
  data() {
    return {
      REFS
    }
  }
}
</script>

<style lang="scss" scoped>
$border-size-desktop-full-hd: 1px;

.content-wrapper {
  max-width: $desktop-container;
  border: none;
  position: relative;
  min-width: 320px;
  margin: 0 auto;
  height: 100%;

  @include desktop-sm {
    border: none;
  }
}
</style>
